export default __webpack_public_path__ + "static/media/welcomeInfo2.d25c2b2e.png";